import { M1OverviewPage } from "./M1OverviewPage";

const M1Overview = () => {
	return <M1OverviewPage />;
};
export default M1Overview;
